import { RootState } from "../store";

// Basic selectors
export const selectAiSummaryState = (state: RootState) => state.aiSummary;

export const selectAiSummaries = (state: RootState) => state.aiSummary.aiSummaries;

export const selectAiSummariesLoading = (state: RootState) => state.aiSummary.loading;

export const selectAiSummariesError = (state: RootState) => state.aiSummary.error;

// Update-related selectors
export const selectAiSummariesUpdateLoading = (state: RootState) => state.aiSummary.updateLoading;

export const selectAiSummariesUpdateError = (state: RootState) => state.aiSummary.updateError;

export const selectAiSummariesUpdateSuccess = (state: RootState) => state.aiSummary.updateSuccess;

// Helper selector to check if a specific section is loading
export const selectAiSummariesUpdateLoadingForSection = (sectionKey: string) => (state: RootState) => 
    state.aiSummary.updateLoading[sectionKey] || false;

// Helper selector to check if any section is loading (for "Save All" button)
export const selectAnyAiSummariesUpdateLoading = (state: RootState) => 
    Object.values(state.aiSummary.updateLoading).some(loading => loading);